import { InputTag } from 'mixs/base/input_mixin';
// import TimeLag from 'utilities/timelag';
interface IItem {
  index: number,
  value: string,
  checked: boolean,
  label: string
}
class Wrap {
}
export class ComplexDeliveryOtherAttachments extends InputTag {
  items: Array<IItem> = [];
  // updateLag: TimeLag;
  labels: Array<string> = [
    '①', '②', '③', '④', '⑤', '⑥', '⑦', '⑧', '⑨', '⑩'
  ]
  public init() {
    super.init();
    // this.updateLag = new TimeLag((params) => { this.onChangeTextDo(params) }, 500);
    this.watch();
    this.initItems()
    this.listenMount([this.onMountTag])
  }
  public onMountTag(){
    this.updateJSON()
  }
  public initItems(){
    const value = this.opts.value
    if(!value){
      this.setInitItems()
    }else{
      const jsonValue = JSON.parse(value)
      let items = []
      for(let i=0; i<jsonValue.length; i++){
        const json = jsonValue[i];
        let label = this.labels[i]
        if(!label){ label = (i + 1).toString() }
        items.push({
          label: label,
          value: json.filename,
          inclusion: json.inclusion,
          checked: true
        })
      }
      items.push(this.initialItem(items.length))
      this.items = items
    }
  }
  public setInitItems(){
    const jsonString = `[${this.initialJsonString(0)}]`
    this.items = JSON.parse(jsonString)
  }
  public initialJsonString(index: number){
    return JSON.stringify(this.initialItem(index))
  }
  public initialItem(index: number, value: string = '', checked: boolean = false, inclusion: boolean = true){
    let label = this.labels[index]
    if(!label){ label = (index + 1).toString() }
    return {
      label: label,
      value: value,
      checked: checked,
      inclusion: inclusion
    }
  }
  public onChangeCheckbox(e){
    if(e.target.checked){ this.focusTextField(e.target)}
    else{
      this.clearText(e.target)
      this.items = this.getNewItemsByText();
    }
    this.updateJSON()
  }
  public onChangeText(e){
    const length = this.items.length
    this.items = this.getNewItemsByText();
    this.updateJSON()
    // if(this.items.length > length){
    //   setTimeout(() => { this.focusNextInput() }, 1)
    // }
  }
  // public updateLagged(length=Infinity){
  //   console.log(length)
  //   console.log('updateLagged')
  //   this.updateItems()
  //   this.updateJSON()
  //   if(this.items.length > length){
  //     setTimeout(() => { this.focusNextInput() }, 1)
  //   }
  // }
  // public updateItems(){
  //   this.items = this.getNewItems();
  // }
  public focusNextInput(){
    const textfields = this.querySelectorAll(`input[type="text"]`)
    const textfield = textfields[textfields.length - 1] as HTMLInputElement
    textfield.focus()
  }
  public getNewItemsByText(){
    const wraps = this.querySelectorAll('.wrap')
    let items = []
    for(let i = 0; i < wraps.length; i++){
      let item = this.initialItem(i)
      const wrap = wraps[i] as HTMLElement
      const textfield = wrap.querySelector('input[type="text"]') as HTMLInputElement
      const value = textfield.value
      const inclusion = this.getInclusion(wrap.querySelectorAll('input[type="radio"]'))
      if(value == '') { continue }
      item.value = value
      item.inclusion = inclusion == '1'
      item.checked = value != '' ? true : false
      items.push(item)
    }
    items.push(this.initialItem(items.length))
    this.resetLabels(items)
    return items
 }
  public getNewItemsByRadio(){
    const wraps = this.querySelectorAll('.wrap')
    let items = []
    for(let i = 0; i < wraps.length; i++){
      let item = this.initialItem(i)
      const wrap = wraps[i] as HTMLElement
      const textfield = wrap.querySelector('input[type="text"]') as HTMLInputElement
      const value = textfield.value
      const inclusion = this.getInclusion(wrap.querySelectorAll('input[type="radio"]'))
      item.value = value
      item.inclusion = inclusion == '1'
      item.checked = value != '' ? true : false
      items.push(item)
    }
    this.resetLabels(items)
    return items
  }
  public resetLabels(items){
    for(let i = 0; i < items.length; i++){
      let label = this.labels[i]
      if(!label){ label = (i + 1).toString() }
      items[i].label = label
    }
    return items
  }
  public getInclusion(radios){
    for(let i=0; i<radios.length; i++){
      const radio = radios[i] as HTMLInputElement
      if(radio.checked){ return radio.value }
    }
    return ''
  }
  public clearText(checkbox){
    const textfields = this.querySelectorAll(`.wrap input[type="text"]`)
    const checkboxies = this.querySelectorAll(`.wrap input[type="checkbox"]`)
    for(let i=0; i<checkboxies.length; i++){
      if(checkboxies[i] == checkbox){
        const textfield = textfields[i] as HTMLInputElement
        textfield.value = ''
        break
      }
    }
  }
  public focusTextField(checkbox){
    const textfield = checkbox.parentElement.parentElement.querySelector('input[type="text"]') as HTMLInputElement
    textfield.focus()
  }
  public updateJSON(){
    let json = this.objectArray(this.items)
    let value = JSON.stringify(json)
    this.dispatch({ value: value })
  }
  public objectArray(items){
    let array = []
    for(let i = 0; i < items.length; i++){
      if(items[i].value != ''){
        array.push({
          inclusion: items[i].inclusion,
          filename: items[i].value
        })
      }
    }
    return array
  }
  public onChangeInclusion(e){
    this.items = this.getNewItemsByRadio();
    this.updateJSON()
  }
}

riot.mixin('inputs.complex.delivery-other-attachments', ComplexDeliveryOtherAttachments as riot.TagMixin)
